export const SupportedViewTypes = [
  'plot-stacked',
  'plot-overlay',
  'bar-graph.view',
  'time-strip.view',
  'example.imagery',
  'timelist.view'
];
